export { AVATAR_TONES, errorMessage, formatCount, initials, RamoMark } from '../../customers/common/customer-common'
export { compactAmount } from '../../../utils/numbers'
export { currentMonthName, currentYear, daysFromToday, formatDayMonth, formatWeekdayName, monthSegmentsIso, shiftIso, todayIso } from '../../../utils/dates'

export const SUMMARY_PATH = '/resumen'
